<template>
  <div>

    <b-container fluid>

      <b-navbar toggleable="md" v-if="isSiteAdmin">

        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <!-- <b-navbar-brand to="/">
          NAB
        </b-navbar-brand> -->

        <b-collapse is-nav id="nav_collapse">

          <b-navbar-nav>
            <b-nav-item to="/station">Stations</b-nav-item>
            <b-nav-item to="/allergen">Allergens</b-nav-item>
            <b-nav-item to="/applicationUser">Users</b-nav-item>
            <b-nav-item to="/allergenCollectionSet">Collections</b-nav-item>
            <b-nav-item to="/scaleSet/master">MCL</b-nav-item>
            <b-nav-item to="/contentBlock">Content</b-nav-item>
            <b-nav-item to="/report/adHoc">Ad-Hoc Reporting</b-nav-item>
            <b-nav-item to="/report/admin">Admin Reporting</b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto">
            <!-- <b-nav-item to="/testing">Testing Notes</b-nav-item> -->
            <!-- <b-nav-item-dropdown right>
              <template slot="button-content">
                Debugging
              </template>
              <b-dropdown-item href="/hangfire" target="_blank">Hangfire</b-dropdown-item>
              <b-dropdown-item href="/ui/playground" target="_blank">GraphQL Playground</b-dropdown-item>
            </b-nav-item-dropdown> -->
            <auth-dropdown></auth-dropdown>
          </b-navbar-nav>

        </b-collapse>
      </b-navbar>

      <!-- Ths if/else here clears the keep-alive when a user logs in/out: https://stackoverflow.com/questions/52967418/refresh-pages-in-vue-js-keep-alive-section -->
      <keep-alive include="StationList" v-if="$root.$data.authenticatedUser.username">
        <router-view></router-view>
      </keep-alive>
      <router-view v-else></router-view>

      <hr />

      <div class="text-center link-set">
        <span class="link-set-link">
          <b-link to="/">Home</b-link>
        </span>
        <span class="link-set-link" v-if="$root.$data.authenticatedUser.username">
          <b-link to="/logout">Log Out {{$root.$data.authenticatedUser.username}}</b-link>
        </span>
        <span class="link-set-link" v-if="!$root.$data.authenticatedUser.username">
          <b-link to="/login">Log In</b-link>
        </span>
      </div>
      <div class="text-center">
        &copy; {{year}} American Academy of Allergy, Asthma &amp; Immunology. All Rights Reserved.
      </div>

    </b-container>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'app',
  methods: {
    showToast: function (text, options) {
      this.$bvToast.toast(text, options);
    }
  },
  computed: {
    isSiteAdmin: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('SiteAdmin');
    },
    year: function () {
      return new Date().getFullYear();
    }
  },
  mounted() {
    if ((!this.$root.$data.authenticatedUser || !this.$root.$data.authenticatedUser.username) && localStorage.getItem('jwt')) {
      axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('jwt');

      this.$root.$data.authenticatedUser.username = localStorage.getItem('username');
      this.$root.$data.authenticatedUser.id = localStorage.getItem('id');
      this.$root.$data.authenticatedUser.roles = JSON.parse(localStorage.getItem('roles'));
      this.$root.$data.authenticatedUser.stationRoles = JSON.parse(localStorage.getItem('stationRoles'));
    }
  }
}
</script>
